import React from "react";

import { IconProps } from "../../types/common";

const PriorityLowIcon = ({
  width = "16",
  height = "16",
  style,
  className,
  fillClassName,
  fillColor = "#007AFF",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 16 16"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={fillColor!}
      className={fillClassName}
      d="M7.33667 3.47233V10.919L4.08333 7.66566C3.82333 7.40566 3.39667 7.40566 3.13667 7.66566C2.87667 7.92566 2.87667 8.34566 3.13667 8.60566L7.53 12.999C7.79 13.259 8.21 13.259 8.47 12.999L12.8633 8.60566C13.1233 8.34566 13.1233 7.92566 12.8633 7.66566C12.7388 7.54083 12.5697 7.47067 12.3933 7.47067C12.217 7.47067 12.0479 7.54083 11.9233 7.66566L8.67 10.919V3.47233C8.67 3.10566 8.37 2.80566 8.00333 2.80566C7.63667 2.80566 7.33667 3.10566 7.33667 3.47233Z"
    />
  </svg>
);

export default PriorityLowIcon;
